import { SliderToaster } from '@slider/ui';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet, useRouter, type ErrorComponentProps } from '@tanstack/react-router';

import { ErrorAppearance } from '../features/error-states/error-appearance';
import { ErrorState } from '../features/error-states/error-state';
import { getErrorRequestId, resolveErrorStateKind } from '../features/error-states/error-state-config';

type RouterContext = {
  queryClient: QueryClient;
};

const NotFound = () => (
  <ErrorAppearance><ErrorState kind="404" /></ErrorAppearance>
);

function RootError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  return (
    <ErrorAppearance>
      <ErrorState
        kind={resolveErrorStateKind(error)}
        requestId={getErrorRequestId(error)}
        onRetry={() => {
          reset();
          void router.invalidate();
        }}
      />
    </ErrorAppearance>
  );
}

// A single Toaster mount serves every shell; toasts confirm completed work and
// are never the only channel for an error.
const RootLayout = () => (
  <>
    <Outlet />
    <SliderToaster />
  </>
);

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
  errorComponent: RootError,
});
